// Angular imports
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'; //Required by PrimeNg file upload control.
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// PrimeNg imports
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

// app imports
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DataViewModule } from 'primeng/dataview';
// ngx-formly imports
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';

// dspx-core imports
import {
    AddressFieldType,
    AutoCompleteFieldType,
    ButtonFieldType,
    CardSectionFieldType,
    CardSectionOverviewFieldType,
    CardSectionRepeatingFieldType,
    CardSetPageFieldType,
    CardSetPageInfoFieldType,
    CardSetPageListFieldType,
    CardSetPageOverviewFieldType,
    CardSetPageRepeatingFieldType,
    CardSetTabsFieldType,
    CardSetTabsFlatFieldType,
    CheckboxFieldType,
    DateFieldType,
    DateTimeFieldType,
    //MapFieldType,
    DisplayFieldType,
    DocumentListFieldType,
    DspxCoreModule,
    DspxRadioWrapperFormField,
    DspxWrapperContainer,
    DspxWrapperFilter,
    DspxWrapperFormField,
    EditorFieldType,
    ExcelFileUploadType,
    FileUploadFieldType,
    FileUploadModule,
    FilterFieldType,
    FormNavigationFieldType,
    FormSummaryFieldType,
    HeaderFieldType,
    HorizontalStepperFieldType,
    HtmlHeadingFieldType,
    ImageFieldType,
    InputFieldType,
    ListFieldType,
    MaskedInputFieldType,
    MessageListFieldType,
    MessagesModule,
    MultiselectFieldType,
    NoteListFieldType,
    PBIEmbeddedFieldType,
    PageFieldType,
    PageRepeatingFieldType,
    PaginatorModule,
    ParagraphFieldType,
    PasswordFieldType,
    RadioFieldType,
    RelatedEntitySummaryFieldType,
    SearchBoxFieldType,
    SectionFieldType,
    SectionRepeatingFieldType,
    SelectButtonFieldType,
    SelectFieldType,
    SingleCheckboxFieldType,
    StepsFieldType,
    SwitchFieldType,
    TableFieldType,
    TableModule,
    TabsFieldType,
    TextAreaFieldType,
    TimeFieldType,
    TimelineFieldType,
    VerticalStepperFieldType,
    customValidator,
    dateGreaterThanOrEqualToValidator,
    dateGreaterThanValidator,
    dateLessThanOrEqualToValidator,
    dateLessThanValidator,
    dateValidator,
    differentToValidator,
    dspxRequiredValidator,
    eitherMandatoryValidator,
    numberGreaterThanValidator,
    numberLessThanValidator,
    sameAsValidator,
    timeValidator,
    urlValidator,
    verificationRequiredValidator,
    whitespaceValidator
} from 'dspx-core';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { AgencyListComponent } from './components/agency-list/agency-list.component';
import { AgencyComponent } from './components/agency/agency.component';
import { ApplicationDetailConcessionsComponent } from './components/application-detail-concessions/application-detail-concessions.component';
import { ApplicationDetailCreateUpdateCarerComponent } from './components/application-detail-create-update-carer/application-detail-create-update-carer.component';
import { ApplicationDetailCreateUpdatePlacementComponent } from './components/application-detail-create-update-placement/application-detail-create-update-placement.component';
import { BankDetailsComponent } from './components/bank-detail/bank-detail.component';
import { CareAllowanceApplicationListComponent } from './components/care-allowance-application-list/care-allowance-application-list.component';
import { CareAllowanceInvoicePeriodComponent } from './components/care-allowance-invoice-period/care-allowance-invoice-period.component';
import { CareAllowancePlacementAdjustmentListComponent } from './components/care-allowance-placement-adjustment-list/care-allowance-placement-adjustment-list.component';
import { CareAllowancePlacementAdjustmentComponent } from './components/care-allowance-placement-adjustment/care-allowance-placement-adjustment.component';
import { CareAllowancePlacementBulkAdHocInvoiceQueryListComponent } from "./components/care-allowance-placement-bulk-ad-hoc-invoice-query-list/care-allowance-placement-bulk-ad-hoc-invoice-query-list.component";
import { CareAllowancePlacementBulkAdHocInvoiceQueryComponent } from "./components/care-allowance-placement-bulk-ad-hoc-invoice-query/care-allowance-placement-bulk-ad-hoc-invoice-query.component";
import { CareAllowancePlacementInvoiceListComponent } from './components/care-allowance-placement-invoice-list/care-allowance-placement-invoice-list.component';
import { CareAllowancePlacementListComponent } from './components/care-allowance-placement-list/care-allowance-placement-list.component';
import { CareAllowancePlacementRuleListComponent } from './components/care-allowance-placement-rule-list/care-allowance-placement-rule-list.component';
import { CareAllowancePlacementRuleComponent } from './components/care-allowance-placement-rule/care-allowance-placement-rule.component';
import { CareAllowancePlacementComponent } from './components/care-allowance-placement/care-allowance-placement.component';
import { CareAllowanceRateListComponent } from './components/care-allowance-rate-list/care-allowance-rate-list.component';
import { CareAllowanceRateComponent } from './components/care-allowance-rate/care-allowance-rate.component';
import { CareAllowanceYearListComponent } from './components/care-allowance-year-list/care-allowance-year-list.component';
import { CareAllowanceYearComponent } from './components/care-allowance-year/care-allowance-year.component';
import { ConcessionsApplicationBulkUploadDetailComponent } from './components/concessions-application-bulk-upload-detail/concessions-application-bulk-upload-detail.component';
import { ConcessionsApplicationBulkUploadErrorLogListComponent } from './components/concessions-application-bulk-upload-error-log-list/concessions-application-bulk-upload-error-log-list.component';
import { ConcessionsApplicationBulkUploadListComponent } from './components/concessions-application-bulk-upload-list/concessions-application-bulk-upload-list.component';
import { ConcessionsApplicationBulkUploadComponent } from './components/concessions-application-bulk-upload/concessions-application-bulk-upload.component';
import { ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent } from './components/concessions-application-eda-and-pow-gold-card-municipal-rates/concessions-application-eda-and-pow-gold-card-municipal-rates.component';
import { ConcessionsApplicationInfoComponent } from './components/concessions-application-info/concessions-application-info.component';
import { ConcessionsApplicationListComponent } from './components/concessions-application-list/concessions-application-list.component';
import { ConcessionsApplicationNonMainsEnergyComponent } from './components/concessions-application-non-mains-energy/concessions-application-non-mains-energy.component';
import { ConcessionsApplicationNonMainsLifeSupportComponent } from './components/concessions-application-non-mains-life-support/concessions-application-non-mains-life-support.component';
import { ConcessionsApplicationNonMainsMedicalCoolingComponent } from './components/concessions-application-non-mains-medical-cooling/concessions-application-non-mains-medical-cooling.component';
import { ConcessionsApplicationNonMainsWaterComponent } from './components/concessions-application-non-mains-water/concessions-application-non-mains-water.component';
import { ConcessionsApplicationReadyForApprovalListComponent } from './components/concessions-application-ready-for-approval-list/concessions-application-ready-for-approval-list.component';
import { ConcessionsApplicationRebateCalculationRuleListComponent } from './components/concessions-application-rebate-calculation-rule-list/concessions-application-rebate-calculation-rule-list.component';
import { ConcessionsInvoiceListComponent } from './components/concessions-invoice-list/concessions-invoice-list.component';
import { ConcessionsRebateCalculationRuleComponent } from './components/concessions-rebate-calculation-rule/concessions-rebate-calculation-rule.component';
import { ErrorLogListComponent } from './components/error-log-list/error-log-list.component';
import { ExportedInvoiceListComponent } from './components/exported-invoice-list/exported-invoice-list.component';
import { ExportedInvoiceComponent } from './components/exported-invoice/exported-invoice.component';
import { GLStringLookupMappingSetListComponent } from './components/gl-string-lookup-mapping-set-list/gl-string-lookup-mapping-set-list.component';
import { GLStringLookupMappingSetComponent } from './components/gl-string-lookup-mapping-set/gl-string-lookup-mapping-set.component';
import { GLStringLookupMappingComponent } from './components/gl-string-lookup-mapping/gl-string-lookup-mapping.component';
import { GLStringMappingListComponent } from './components/gl-string-mapping-list/gl-string-mapping-list.component';
import { GLStringMappingComponent } from './components/gl-string-mapping/gl-string-mapping.component';
import { IccmsRequestProcessingScheduleListComponent } from './components/iccms-request-processing-schedule-list/iccms-request-processing-schedule-list.component';
import { IccmsRequestProcessingScheduleComponent } from './components/iccms-request-processing-schedule/iccms-request-processing-schedule.component';
import { JobRunLogListComponent } from './components/job-run-log-list/job-run-log-list.component';
import { JobScheduleListComponent } from './components/job-schedule-list/job-schedule-list.component';
import { JobScheduleComponent } from './components/job-schedule/job-schedule.component';
import { LandingComponent } from './components/landing/landing.component';
import { MultiFormCompatibleCardSetFormComponent } from './components/multi-form-compatible-card-set-form/multi-form-compatible-card-set-form.component';
import { OrganisationListComponent } from './components/organisation-list/organisation-list.component';
import { OrganisationComponent } from './components/organisation/organisation.component';
import { PaymentRuleComponent } from './components/payment-rule/payment-rule.component';
import { PersonDetailComponent } from './components/person-detail/person-detail.component';
import { PersonListComponent } from './components/person-list/person-list.component';
import { ReferenceDataListComponent } from './components/reference-data-list/reference-data-list.component';
import { ReferenceDataComponent } from './components/reference-data/reference-data.component';
import { ReportListComponent } from './components/report-list/report-list.component';
import { SettingListComponent } from './components/setting-list/setting-list.component';
import { SettingComponent } from './components/setting/setting.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserComponent } from './components/user/user.component';
import { VendorListComponent } from './components/vendor-list/vendor-list.component';
import { VendorComponent } from './components/vendor/vendor.component';
import { VmgEmailTemplateComponent } from './components/vmg-email-template/vmg-email-template.component';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { CareAllowanceLocalAdoptionComponent } from './components/care-allowance-local-adoption/care-allowance-local-adoption.component';
import { CareAllowancePersonComponent } from './components/care-allowance-person/care-allowance-person.component';
import { VictorianPatientTransportAssistanceSchemeApplicationListComponent } from './components/vptas-application-list/victorian-patient-transport-assistance-scheme-application-list.component';
import { VictorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateListComponent } from './components/vpts-application-rebate-calculation-rate-list/victorian-patient-transport-assistance-scheme-application-rebate-calculation-rate-list.component';
import { VictorianPatientTransportAssistanceSchemeRebateCalculationRuleComponent } from './components/vpts-rebate-calculation-rule/victorian-patient-transport-assistance-scheme-rebate-calculation-rule.component';
import { VictorianPatientTransportAssistanceSchemeNominatedPatientDetailsComponent } from './components/victorian-patient-transport-assistance-scheme-nominated-patient-details/victorian-patient-transport-assistance-scheme-nominated-patient-details.component';
import { VptasDocumentListFieldType } from './components/document-list/document-list.type';
import { VptasApplicationSubsidyListComponent } from './components/vptas-application-subsidy-list/vptas-application-subsidy-list.component';
import { VptasApplicationTripListComponent } from './components/vptas-application-trip-list/vptas-application-trip-list.component';
import { VptasInvoiceListComponent } from './components/vptas-invoice-list/vptas-invoice-list.component';
import { CustomFormSummaryFieldType } from './components/form-summary/formsummary.type';
import { VictorianPatientTransportAssistanceSchemeApplication } from './components/victorian-patient-transport-assistance-scheme-application/victorian-patient-transport-assistance-scheme-application.component';
import { ApplicationDetailVptasComponent } from './components/application-detail-vptas/application-detail-vptas.component';
import { VptasSpecialistListComponent } from './components/vptas-specialist-list/vptas-specialist-list.component';
import { VptasSpecialistComponent } from './components/vptas-specialist/vptas-specialist.component';
import { VptasSpecialistProviderInformationComponent } from './components/vptas-specialist-provider-information/vptas-specialist-provider-information.component';
import { VptasLGAListComponent } from './components/vptas-lga-list/vptas-lga-list.component';
import { VptasLgaComponent } from './components/vptas-lga/vptas-lga.component';
import { VptasAdjustmentApplication } from './components/vptas-adjustment-application/vptas-adjustment-application.component';
import { VptasSpecialistSearchFormComponent } from './components/vptas-specialist-search-form/vptas-specialist-search-form.component';
import { VptasApplicationSubsidyComponent } from './components/vptas-application-subsidy/vptas-application-subsidy.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    MultiFormCompatibleCardSetFormComponent,
    ReferenceDataComponent,
    ReferenceDataListComponent,
    GLStringMappingComponent,
    GLStringMappingListComponent,
    GLStringLookupMappingSetComponent,
    GLStringLookupMappingSetListComponent,
    GLStringLookupMappingComponent,
    SettingComponent,
    SettingListComponent,
    UserComponent,
    UserListComponent,
    OrganisationComponent,
    OrganisationListComponent,
    CareAllowanceApplicationListComponent,
    CareAllowanceYearListComponent,
    CareAllowanceYearComponent,
    CareAllowanceRateListComponent,
    CareAllowanceRateComponent,
    IccmsRequestProcessingScheduleListComponent,
    IccmsRequestProcessingScheduleComponent,
    ConcessionsApplicationListComponent,
    ConcessionsApplicationReadyForApprovalListComponent,
    VendorListComponent,
    VendorComponent,
    ErrorLogListComponent,
    ApplicationDetailCreateUpdateCarerComponent,
    ApplicationDetailCreateUpdatePlacementComponent,
    PaymentRuleComponent,
    PersonListComponent,
    PersonDetailComponent,
    VmgEmailTemplateComponent,
    ApplicationDetailConcessionsComponent,
    CareAllowancePlacementRuleListComponent,
    CareAllowancePlacementRuleComponent,
    CareAllowanceInvoicePeriodComponent,
    CareAllowancePlacementListComponent,
    CareAllowancePlacementComponent,
    CareAllowancePlacementAdjustmentListComponent,
    CareAllowancePlacementAdjustmentComponent,
    CareAllowancePlacementInvoiceListComponent,
    CareAllowancePlacementBulkAdHocInvoiceQueryListComponent,
    CareAllowancePlacementBulkAdHocInvoiceQueryComponent,
    ConcessionsApplicationNonMainsWaterComponent,
    ConcessionsApplicationNonMainsEnergyComponent,
    ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent,
    ConcessionsApplicationNonMainsLifeSupportComponent,
    ConcessionsApplicationNonMainsMedicalCoolingComponent,
    ConcessionsApplicationInfoComponent,
    ConcessionsApplicationRebateCalculationRuleListComponent,
    ConcessionsApplicationBulkUploadComponent,
    ConcessionsRebateCalculationRuleComponent,
    JobScheduleListComponent,
    JobScheduleComponent,
    JobRunLogListComponent,
    ConcessionsInvoiceListComponent,
    ExportedInvoiceListComponent,
    ExportedInvoiceComponent,
    BankDetailsComponent,
    ConcessionsApplicationBulkUploadErrorLogListComponent,
    ReportListComponent,
    ConcessionsApplicationBulkUploadListComponent,
    AgencyListComponent,
    AgencyComponent,
    ConcessionsApplicationBulkUploadDetailComponent,
    CareAllowancePersonComponent,
    CareAllowanceLocalAdoptionComponent,
    VictorianPatientTransportAssistanceSchemeApplicationListComponent,
    VictorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateListComponent,
    VictorianPatientTransportAssistanceSchemeRebateCalculationRuleComponent,
    VictorianPatientTransportAssistanceSchemeNominatedPatientDetailsComponent,
    VptasDocumentListFieldType,
    VptasApplicationSubsidyListComponent,
    VptasApplicationTripListComponent,
    VptasInvoiceListComponent,
    CustomFormSummaryFieldType,
    VictorianPatientTransportAssistanceSchemeApplication,
    ApplicationDetailVptasComponent,
    VptasSpecialistListComponent,
    VptasSpecialistComponent,
    VptasSpecialistProviderInformationComponent,
    VptasLGAListComponent,
    VptasLgaComponent,
    VptasAdjustmentApplication,
    VptasSpecialistSearchFormComponent,
    VptasApplicationSubsidyComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    DspxCoreModule,
    MessagesModule,
    CardModule,
    DynamicDialogModule,
    ButtonModule,
    AvatarModule,
    AccordionModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormlyPrimeNGModule,
    HttpClientModule,
    DataViewModule,
    FileUploadModule,
    TableModule,
    PaginatorModule,
    
    FormlyModule.forRoot({
      wrappers: [
        { name: 'dspx-form-field', component: DspxWrapperFormField },
        { name: 'dspx-container', component: DspxWrapperContainer },
        { name: 'dspx-radio-wrapper', component: DspxRadioWrapperFormField },
        { name: 'dspx-filter-wrapper', component: DspxWrapperFilter },
      ],
      types: [
        { name: 'input', component: InputFieldType, wrappers: ['dspx-form-field'] },
        { name: 'checkbox', component: SingleCheckboxFieldType, wrappers: ['dspx-form-field'] },
        { name: 'radio', component: RadioFieldType, wrappers: ['dspx-radio-wrapper'] },
        { name: 'select', component: SelectFieldType, wrappers: ['dspx-form-field'] },
        { name: 'multicheckbox', component: CheckboxFieldType, wrappers: ['dspx-form-field'] },
        { name: 'switch', component: SwitchFieldType, wrappers: ['dspx-form-field'] },
        { name: 'button', component: ButtonFieldType },
        { name: 'date', component: DateFieldType, wrappers: ['dspx-form-field'] },
        { name: 'datetime', component: DateTimeFieldType, wrappers: ['dspx-form-field'] },
        { name: 'file', component: FileUploadFieldType, wrappers: ['dspx-form-field'] },
        { name: 'autocomplete', component: AutoCompleteFieldType, wrappers: ['dspx-form-field'] },
        { name: 'address', component: AddressFieldType, wrappers: ['dspx-form-field'] },
        { name: 'maskedinput', component: MaskedInputFieldType, wrappers: ['dspx-form-field'] },
        { name: 'textarea', component: TextAreaFieldType, wrappers: ['dspx-form-field'] },
        { name: 'multiselect', component: MultiselectFieldType, wrappers: ['dspx-form-field'] },
        { name: 'selectbutton', component: SelectButtonFieldType, wrappers: ['dspx-form-field'] },
        { name: 'paragraph', component: ParagraphFieldType },
        { name: 'password', component: PasswordFieldType, wrappers: ['dspx-form-field'] },
        { name: 'steps', component: StepsFieldType },
        { name: 'tabs', component: TabsFieldType },
        { name: 'page', component: PageFieldType },
        { name: 'page-repeating', component: PageRepeatingFieldType },
        { name: 'section', component: SectionFieldType },
        { name: 'section-repeating', component: SectionRepeatingFieldType },
        { name: 'formnavigation', component: FormNavigationFieldType },
        { name: 'data-grid', component: TableFieldType },
        { name: 'search', component: SearchBoxFieldType, wrappers: ['dspx-container'] },
        { name: 'summary-page', component: PageFieldType, wrappers: ['dspx-container'] },
        { name: 'summary', component: FormSummaryFieldType },
        { name: 'time', component: TimeFieldType, wrappers: ['dspx-form-field'] },
        { name: 'powerbi', component: PBIEmbeddedFieldType, wrappers: ['dspx-container'] },
        { name: 'heading', component: HtmlHeadingFieldType },
        { name: 'filter', component: FilterFieldType },
        { name: 'selectbutton', component: SelectButtonFieldType, wrappers: ['dspx-form-field'] },
        { name: 'editor', component: EditorFieldType, wrappers: ['dspx-form-field'] },
        { name: 'heading', component: HtmlHeadingFieldType },
        { name: 'image', component: ImageFieldType },
        { name: 'excel-file-upload', component: ExcelFileUploadType, wrappers: ['dspx-form-field'] },
        { name: 'related-entity-summary', component: RelatedEntitySummaryFieldType },
        //{ name: 'map', component: MapFieldType, wrappers: ['dspx-form-field'] },
        { name: 'display', component: DisplayFieldType },
        { name: 'list', component: ListFieldType },
        { name: 'message-list', component: MessageListFieldType },
        { name: 'document-list', component: DocumentListFieldType },
        { name: 'vertical-stepper', component: VerticalStepperFieldType },
        { name: 'horizontal-stepper', component: HorizontalStepperFieldType },
        { name: 'header', component: HeaderFieldType },
        { name: 'timeline', component: TimelineFieldType, wrappers: ['dspx-form-field'] },
        { name: 'note-list', component: NoteListFieldType },
        // 'card-set' layout
        { name: 'card-set-tabs', component: CardSetTabsFieldType },
        { name: 'card-set-tabs-flat', component: CardSetTabsFlatFieldType },
        { name: 'card-set-page', component: CardSetPageFieldType },
        { name: 'card-set-page-repeating', component: CardSetPageRepeatingFieldType },
        { name: 'card-set-page-overview', component: CardSetPageOverviewFieldType },
        { name: 'card-set-page-info', component: CardSetPageInfoFieldType },
        { name: 'card-set-page-list', component: CardSetPageListFieldType },
        { name: 'card-section', component: CardSectionFieldType },
        { name: 'card-section-repeating', component: CardSectionRepeatingFieldType },
        { name: 'card-section-overview', component: CardSectionOverviewFieldType },
      ],
      validators: [
        { name: 'dspxRequired', validation: dspxRequiredValidator },
        { name: 'whitespace', validation: whitespaceValidator },
        { name: 'sameAs', validation: sameAsValidator },
        { name: 'differentTo', validation: differentToValidator },
        { name: 'eitherMandatory', validation: eitherMandatoryValidator },
        { name: 'anyOneMandatory', validation: eitherMandatoryValidator },
        { name: 'mandatoryPartialDate', validation: eitherMandatoryValidator },
        { name: 'date', validation: dateValidator },
        { name: 'dateLessThan', validation: dateLessThanValidator },
        { name: 'dateLessThanOrEqualTo', validation: dateLessThanOrEqualToValidator },
        { name: 'dateGreaterThan', validation: dateGreaterThanValidator },
        { name: 'dateGreaterThanOrEqualTo', validation: dateGreaterThanOrEqualToValidator, },
        { name: 'numberGreaterThan', validation: numberGreaterThanValidator },
        { name: 'numberLessThan', validation: numberLessThanValidator },
        { name: 'verificationRequired', validation: verificationRequiredValidator },
        { name: 'time', validation: timeValidator },
        { name: 'custom', validation: customValidator },
        { name: 'url', validation: urlValidator },
      ],
      extras: {
        resetFieldOnHide: true,
        checkExpressionOn: 'modelChange',
        lazyRender: true,
      },
    }),
  ],
  providers: [PendingChangesGuard, DialogService],
  bootstrap: [AppComponent],
})
export class AppModule {
}
